import { render, staticRenderFns } from "./class-promotion-v1.vue?vue&type=template&id=64f6f385&"
import script from "./class-promotion-v1.vue?vue&type=script&lang=js&"
export * from "./class-promotion-v1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports